export default "__VITE_ASSET__QSe9XWoI__"